import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/index.jsx";
import "./MainBody.css";
import BodyInside from "./MainPageContent/BodyInside";
import EquityDesign from "./EquityDesign.jsx";
import Testimonial from "./MainPageContent/Testimonial";
import CarouselOne from "./MainPageContent/CarouselOne.jsx";
import aqtVideo from "../../assets/videos/aqt.mp4";
import {Partner } from "../../components/Partner/Partner.jsx";

export default function MainBody() {
  return (
    <>
      <Navbar />
      
      {/* Main Banner */}
      <div className="main-banner">
        <video autoPlay loop muted playsInline className="banner-video">
          <source src={aqtVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className="banner-content">
          <h1>SCALE YOUR BUSINESS</h1>
          <p>
            Achieve exponential growth with AQT's tailored{" "}
            <span className="break-after">financial</span> solutions designed to
            meet your business needs.
          </p>
        </div>
      </div>

      {/* Carousel Section */}
      <div style={{ backgroundColor: "#EEF5F9" }}>
        <CarouselOne />
      </div>
      
      {/* <Partner /> */}

      {/* Content Sections */}
      <div style={{ backgroundColor: "#EEF5F9" }}>
        <BodyInside />
      </div>
      
      <EquityDesign />
      
      <Testimonial />
     <Partner />
      <Footer />
    </>
  );
}